var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "currentColor",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1756 12.7502V11.9351C12.1756 11.5028 12.0039 11.0881 11.6981 10.7824C11.3924 10.4767 10.9778 10.3049 10.5454 10.3049H7.28499C6.85264 10.3049 6.43799 10.4767 6.13226 10.7824C5.82654 11.0881 5.65479 11.5028 5.65479 11.9351V12.7502",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91585 8.67448C9.81619 8.67448 10.5461 7.94461 10.5461 7.04427C10.5461 6.14393 9.81619 5.41406 8.91585 5.41406C8.01551 5.41406 7.28564 6.14393 7.28564 7.04427C7.28564 7.94461 8.01551 8.67448 8.91585 8.67448Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6221 12.7495V11.9344C14.6218 11.5732 14.5016 11.2223 14.2803 10.9368C14.059 10.6514 13.7491 10.4475 13.3994 10.3572",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20996 12.7416V11.9265C3.21023 11.5653 3.33045 11.2144 3.55175 10.9289C3.77304 10.6434 4.08288 10.4395 4.43262 10.3492",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7686 5.46667C12.1192 5.55646 12.43 5.7604 12.652 6.04634C12.8739 6.33228 12.9944 6.68396 12.9944 7.04594C12.9944 7.40791 12.8739 7.7596 12.652 8.04554C12.43 8.33148 12.1192 8.53542 11.7686 8.6252",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06348 5.4585C5.71281 5.54828 5.402 5.75222 5.18005 6.03816C4.9581 6.3241 4.83762 6.67578 4.83762 7.03776C4.83762 7.39974 4.9581 7.75142 5.18005 8.03736C5.402 8.3233 5.71281 8.52724 6.06348 8.61702",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupTransaction);
export default __webpack_public_path__ + "static/media/group-transaction.8cbd29f070bbf6de44c98073e5f508de.svg";
export { ForwardRef as ReactComponent };